import { Path } from '@/types/global';
import { MonitoringCriminalAlert } from '@/types/turn-api';

export const path = (path: Path<MonitoringCriminalAlert.Base>) => path;
